export enum ClientSpecialCampaignApprovalEnum {
  NotRequested = 0,
  Pending = 1,
  Approved = 2,
  Disapproved = 3,
}
